import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import STRINGS from "../../Constants/Strings";
import { isValidPostalCode } from "./modalUtils";

export const EditAddressModal = ({
  showAddressEditModal,
  handleAddressModalClose,
  applicant,
  handleAddressSaveClick,
  provinceList,
}) => {
  const [addressFormData, setAddressFormData] = useState({
    currentAddressLine1: applicant?.address?.currentAddressLine1 || "",
    currentAddressUnitNumber:
      applicant?.address?.currentAddressUnitNumber || "",
    currentAddressCity: applicant?.address?.currentAddressCity || "",
    currentAddressProvince: applicant?.address?.currentAddressProvince || "",
    currentAddressPostalCode:
      applicant?.address?.currentAddressPostalCode || "",
    currentAddressCountry: applicant?.address?.currentAddressCountry || "CAN",
    mailingSameAsCivic: applicant?.address?.mailingSameAsCivic || false,
    mailingAddressLine1: applicant?.address?.mailingAddressLine1 || "",
    mailingUnitNumber: applicant?.address?.mailingUnitNumber || "",
    mailingCity: applicant?.address?.mailingCity || "",
    mailingProvince: applicant?.address?.mailingProvince || "",
    mailingPostalCode: applicant?.address?.mailingPostalCode || "",
    mailingCountry: applicant?.address?.mailingCountry || "CAN",
  });

  const [addressFormErrors, setAddressFormErrors] = useState({
    currentAddressLine1: "",
    currentAddressCity: "",
    currentAddressProvince: "",
    currentAddressPostalCode: "",
    mailingAddressLine1: "",
    mailingCity: "",
    mailingProvince: "",
    mailingPostalCode: "",
  });

  useEffect(() => {
    setAddressFormData({
      currentAddressLine1: applicant?.address?.currentAddressLine1 || "",
      currentAddressUnitNumber:
        applicant?.address?.currentAddressUnitNumber || "",
      currentAddressCity: applicant?.address?.currentAddressCity || "",
      currentAddressProvince: applicant?.address?.currentAddressProvince || "",
      currentAddressPostalCode:
        applicant?.address?.currentAddressPostalCode || "",
      currentAddressCountry: applicant?.address?.currentAddressCountry || "CAN",
      mailingSameAsCivic: applicant?.address?.mailingSameAsCivic || false,
      mailingAddressLine1: applicant?.address?.mailingAddressLine1 || "",
      mailingUnitNumber: applicant?.address?.mailingUnitNumber || "",
      mailingCity: applicant?.address?.mailingCity || "",
      mailingProvince: applicant?.address?.mailingProvince || "",
      mailingPostalCode: applicant?.address?.mailingPostalCode || "",
      mailingCountry: applicant?.address?.mailingCountry || "CAN",
    });
  }, [applicant]);

  const handleAddressInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setAddressFormData((prev) => ({ ...prev, [name]: checked }));
    } else if (
      name === "currentAddressPostalCode" ||
      name === "mailingPostalCode"
    ) {
      const country =
        name === "currentAddressPostalCode"
          ? addressFormData.currentAddressCountry
          : addressFormData.mailingCountry;

      let formattedValue = value.toUpperCase();
      if (country === "CAN") {
        formattedValue = formattedValue.replace(/[^A-Z0-9]/g, "").slice(0, 6);
        if (formattedValue.length > 3) {
          formattedValue =
            formattedValue.slice(0, 3) + " " + formattedValue.slice(3);
        }
      } else if (country === "USA") {
        formattedValue = value.replace(/[^\d]/g, "").slice(0, 5);
      }

      setAddressFormData((prev) => ({ ...prev, [name]: formattedValue }));
    } else if (name === "currentAddressCountry" || name === "mailingCountry") {
      const isCurrent = name === "currentAddressCountry";
      setAddressFormData((prev) => ({
        ...prev,
        [name]: value,
        [isCurrent ? "currentAddressProvince" : "mailingProvince"]: "",
        [isCurrent ? "currentAddressPostalCode" : "mailingPostalCode"]: "",
      }));
    } else {
      setAddressFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = () => {
    const errors = {
      currentAddressLine1: "",
      currentAddressCity: "",
      currentAddressProvince: "",
      currentAddressPostalCode: "",
      mailingAddressLine1: "",
      mailingCity: "",
      mailingProvince: "",
      mailingPostalCode: "",
    };

    if (!addressFormData.currentAddressLine1?.trim()) {
      errors.currentAddressLine1 =
        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_ADDRESS_DETAILS_MODAL.ERROR_ADDRESS_REQUIRED;
    }
    if (!addressFormData.currentAddressCity?.trim()) {
      errors.currentAddressCity =
        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_ADDRESS_DETAILS_MODAL.ERROR_CITY_REQUIRED;
    }
    if (!addressFormData.currentAddressProvince?.trim()) {
      errors.currentAddressProvince =
        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_ADDRESS_DETAILS_MODAL.ERROR_PROVINCE_REQUIRED;
    }
    if (!addressFormData.currentAddressPostalCode?.trim()) {
      errors.currentAddressPostalCode =
        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_ADDRESS_DETAILS_MODAL.ERROR_POSTAL_REQUIRED;
    } else if (
      !isValidPostalCode(
        addressFormData.currentAddressPostalCode,
        addressFormData.currentAddressCountry
      )
    ) {
      errors.currentAddressPostalCode =
        addressFormData.currentAddressCountry === "CAN"
          ? STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
              .EDIT_ADDRESS_DETAILS_MODAL.ERROR_POSTAL_INVALID_CAN
          : STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
              .EDIT_ADDRESS_DETAILS_MODAL.ERROR_POSTAL_INVALID_USA;
    }

    if (!addressFormData.mailingSameAsCivic) {
      if (!addressFormData.mailingAddressLine1?.trim()) {
        errors.mailingAddressLine1 =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_ADDRESS_DETAILS_MODAL.ERROR_ADDRESS_REQUIRED;
      }
      if (!addressFormData.mailingCity?.trim()) {
        errors.mailingCity =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_ADDRESS_DETAILS_MODAL.ERROR_CITY_REQUIRED;
      }
      if (!addressFormData.mailingProvince?.trim()) {
        errors.mailingProvince =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_ADDRESS_DETAILS_MODAL.ERROR_PROVINCE_REQUIRED;
      }
      if (!addressFormData.mailingPostalCode?.trim()) {
        errors.mailingPostalCode =
          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL.EDIT_ADDRESS_DETAILS_MODAL.ERROR_POSTAL_REQUIRED;
      } else if (
        !isValidPostalCode(
          addressFormData.mailingPostalCode,
          addressFormData.mailingCountry
        )
      ) {
        errors.mailingPostalCode =
          addressFormData.mailingCountry === "CAN"
            ? STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                .EDIT_ADDRESS_DETAILS_MODAL.ERROR_POSTAL_INVALID_CAN
            : STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                .EDIT_ADDRESS_DETAILS_MODAL.ERROR_POSTAL_INVALID_USA;
      }
    }

    setAddressFormErrors(errors);

    const hasErrors = Object.values(errors).some((error) => error !== "");
    if (!hasErrors) {
      handleAddressSaveClick(addressFormData);
      handleAddressModalClose();
    }
  };

  return (
    <Modal
      show={showAddressEditModal}
      onHide={handleAddressModalClose}
      className="[ popup-modal__container ]"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="[ popup-modal__header ]" closeButton>
        <Modal.Title>
          {
            STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
              .EDIT_ADDRESS_DETAILS_MODAL.TITLE
          }
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="[ row ]">
          <div className="[ col-12 ]">
            {/* Residential Address */}
            <h5 className="mb-4 fw-bold">
              {
                STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                  .EDIT_ADDRESS_DETAILS_MODAL.RESIDENTIAL_HEADER
              }
            </h5>

            <div className="[ mb-3 ]">
              <label htmlFor="currentAddressLine1" className="[ form-label ]">
                {
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                    .EDIT_ADDRESS_DETAILS_MODAL.ADDRESS_LABEL
                }
              </label>
              <input
                id="currentAddressLine1"
                type="text"
                name="currentAddressLine1"
                className={`[ form-control ] ${
                  addressFormErrors.currentAddressLine1 ? "[ is-invalid ]" : ""
                }`}
                value={addressFormData.currentAddressLine1}
                onChange={handleAddressInputChange}
              />
              {addressFormErrors.currentAddressLine1 && (
                <div className="[ invalid-feedback ]">
                  {addressFormErrors.currentAddressLine1}
                </div>
              )}
            </div>

            <div className="[ row ]">
              <div className="[ col-6 mb-3 ]">
                <label
                  htmlFor="currentAddressUnitNumber"
                  className="[ form-label ]"
                >
                  {
                    STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                      .EDIT_ADDRESS_DETAILS_MODAL.UNIT_LABEL
                  }
                </label>
                <input
                  id="currentAddressUnitNumber"
                  type="text"
                  name="currentAddressUnitNumber"
                  className="[ form-control ]"
                  value={addressFormData.currentAddressUnitNumber}
                  onChange={handleAddressInputChange}
                />
              </div>
              <div className="[ col-6 mb-3 ]">
                <label htmlFor="currentAddressCity" className="[ form-label ]">
                  {
                    STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                      .EDIT_ADDRESS_DETAILS_MODAL.CITY_LABEL
                  }
                </label>
                <input
                  id="currentAddressCity"
                  type="text"
                  name="currentAddressCity"
                  className={`[ form-control ] ${
                    addressFormErrors.currentAddressCity ? "[ is-invalid ]" : ""
                  }`}
                  value={addressFormData.currentAddressCity}
                  onChange={handleAddressInputChange}
                />
                {addressFormErrors.currentAddressCity && (
                  <div className="[ invalid-feedback ]">
                    {addressFormErrors.currentAddressCity}
                  </div>
                )}
              </div>
            </div>

            <div className="[ row ]">
              <div className="[ col-6 mb-3 ]">
                <label
                  htmlFor="currentAddressProvince"
                  className="[ form-label ]"
                >
                  {
                    STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                      .EDIT_ADDRESS_DETAILS_MODAL.PROVINCE_LABEL
                  }
                </label>
                <select
                  id="currentAddressProvince"
                  name="currentAddressProvince"
                  className={`[ form-control ] ${
                    addressFormErrors.currentAddressProvince
                      ? "[ is-invalid ]"
                      : ""
                  }`}
                  value={addressFormData.currentAddressProvince}
                  onChange={handleAddressInputChange}
                >
                  <option value="">
                    {
                      STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                        .EDIT_ADDRESS_DETAILS_MODAL.SELECT_OPTION
                    }
                  </option>
                  {provinceList
                    .filter(
                      (p) => p.country === addressFormData.currentAddressCountry
                    )
                    .map((p) => (
                      <option key={p.code} value={p.code}>
                        {p.description}
                      </option>
                    ))}
                </select>
                {addressFormErrors.currentAddressProvince && (
                  <div className="[ invalid-feedback ]">
                    {addressFormErrors.currentAddressProvince}
                  </div>
                )}
              </div>
              <div className="[ col-6 mb-3 ]">
                <label
                  htmlFor="currentAddressCountry"
                  className="[ form-label ]"
                >
                  {
                    STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                      .EDIT_ADDRESS_DETAILS_MODAL.COUNTRY_LABEL
                  }
                </label>
                <select
                  id="currentAddressCountry"
                  name="currentAddressCountry"
                  className="[ form-control ]"
                  value={addressFormData.currentAddressCountry}
                  onChange={handleAddressInputChange}
                >
                  <option value="CAN">
                    {
                      STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                        .EDIT_ADDRESS_DETAILS_MODAL.COUNTRY_CANADA
                    }
                  </option>
                  <option value="USA">
                    {
                      STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                        .EDIT_ADDRESS_DETAILS_MODAL.COUNTRY_USA
                    }
                  </option>
                </select>
              </div>
            </div>

            <div className="[ mb-3 ]">
              <label
                htmlFor="currentAddressPostalCode"
                className="[ form-label ]"
              >
                {
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                    .EDIT_ADDRESS_DETAILS_MODAL.POSTAL_LABEL
                }
              </label>
              <input
                id="currentAddressPostalCode"
                type="text"
                name="currentAddressPostalCode"
                className={`[ form-control ] ${
                  addressFormErrors.currentAddressPostalCode
                    ? "[ is-invalid ]"
                    : ""
                }`}
                value={addressFormData.currentAddressPostalCode}
                onChange={handleAddressInputChange}
                placeholder={
                  addressFormData.currentAddressCountry === "CAN"
                    ? STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                        .EDIT_ADDRESS_DETAILS_MODAL.POSTAL_PLACEHOLDER_CAN
                    : STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                        .EDIT_ADDRESS_DETAILS_MODAL.POSTAL_PLACEHOLDER_USA
                }
              />
              {addressFormErrors.currentAddressPostalCode && (
                <div className="[ invalid-feedback ]">
                  {addressFormErrors.currentAddressPostalCode}
                </div>
              )}
            </div>

            {/* Mailing Same as Residential */}
            <div className="[ form-check mb-4 ]">
              <input
                className="[ form-check-input ]"
                type="checkbox"
                id="mailingSameAsCivic"
                name="mailingSameAsCivic"
                checked={addressFormData.mailingSameAsCivic}
                onChange={handleAddressInputChange}
              />
              <label
                className="[ form-check-label ]"
                htmlFor="mailingSameAsCivic"
              >
                {
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                    .EDIT_ADDRESS_DETAILS_MODAL.MAILING_SAME_LABEL
                }
              </label>
            </div>

            {/* Mailing Address (conditional) */}
            {!addressFormData.mailingSameAsCivic && (
              <>
                <h5 className="mb-4 fw-bold">
                  {
                    STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                      .EDIT_ADDRESS_DETAILS_MODAL.MAILING_HEADER
                  }
                </h5>

                <div className="[ mb-3 ]">
                  <label
                    htmlFor="mailingAddressLine1"
                    className="[ form-label ]"
                  >
                    {
                      STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                        .EDIT_ADDRESS_DETAILS_MODAL.ADDRESS_LABEL
                    }
                  </label>
                  <input
                    id="mailingAddressLine1"
                    type="text"
                    name="mailingAddressLine1"
                    className={`[ form-control ] ${
                      addressFormErrors.mailingAddressLine1
                        ? "[ is-invalid ]"
                        : ""
                    }`}
                    value={addressFormData.mailingAddressLine1}
                    onChange={handleAddressInputChange}
                  />
                  {addressFormErrors.mailingAddressLine1 && (
                    <div className="[ invalid-feedback ]">
                      {addressFormErrors.mailingAddressLine1}
                    </div>
                  )}
                </div>

                <div className="[ row ]">
                  <div className="[ col-6 mb-3 ]">
                    <label
                      htmlFor="mailingUnitNumber"
                      className="[ form-label ]"
                    >
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_ADDRESS_DETAILS_MODAL.UNIT_LABEL
                      }
                    </label>
                    <input
                      id="mailingUnitNumber"
                      type="text"
                      name="mailingUnitNumber"
                      className="[ form-control ]"
                      value={addressFormData.mailingUnitNumber}
                      onChange={handleAddressInputChange}
                    />
                  </div>
                  <div className="[ col-6 mb-3 ]">
                    <label htmlFor="mailingCity" className="[ form-label ]">
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_ADDRESS_DETAILS_MODAL.CITY_LABEL
                      }
                    </label>
                    <input
                      id="mailingCity"
                      type="text"
                      name="mailingCity"
                      className={`[ form-control ] ${
                        addressFormErrors.mailingCity ? "[ is-invalid ]" : ""
                      }`}
                      value={addressFormData.mailingCity}
                      onChange={handleAddressInputChange}
                    />
                    {addressFormErrors.mailingCity && (
                      <div className="[ invalid-feedback ]">
                        {addressFormErrors.mailingCity}
                      </div>
                    )}
                  </div>
                </div>

                <div className="[ row ]">
                  <div className="[ col-6 mb-3 ]">
                    <label htmlFor="mailingProvince" className="[ form-label ]">
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_ADDRESS_DETAILS_MODAL.PROVINCE_LABEL
                      }
                    </label>
                    <select
                      id="mailingProvince"
                      name="mailingProvince"
                      className={`[ form-control ] ${
                        addressFormErrors.mailingProvince
                          ? "[ is-invalid ]"
                          : ""
                      }`}
                      value={addressFormData.mailingProvince}
                      onChange={handleAddressInputChange}
                    >
                      <option value="">
                        {
                          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                            .EDIT_ADDRESS_DETAILS_MODAL.SELECT_OPTION
                        }
                      </option>
                      {provinceList
                        .filter(
                          (p) => p.country === addressFormData.mailingCountry
                        )
                        .map((p) => (
                          <option key={p.code} value={p.code}>
                            {p.description}
                          </option>
                        ))}
                    </select>
                    {addressFormErrors.mailingProvince && (
                      <div className="[ invalid-feedback ]">
                        {addressFormErrors.mailingProvince}
                      </div>
                    )}
                  </div>
                  <div className="[ col-6 mb-3 ]">
                    <label htmlFor="mailingCountry" className="[ form-label ]">
                      {
                        STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                          .EDIT_ADDRESS_DETAILS_MODAL.COUNTRY_LABEL
                      }
                    </label>
                    <select
                      id="mailingCountry"
                      name="mailingCountry"
                      className="[ form-control ]"
                      value={addressFormData.mailingCountry}
                      onChange={handleAddressInputChange}
                    >
                      <option value="CAN">
                        {
                          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                            .EDIT_ADDRESS_DETAILS_MODAL.COUNTRY_CANADA
                        }
                      </option>
                      <option value="USA">
                        {
                          STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                            .EDIT_ADDRESS_DETAILS_MODAL.COUNTRY_USA
                        }
                      </option>
                    </select>
                  </div>
                </div>

                <div className="[ mb-3 ]">
                  <label htmlFor="mailingPostalCode" className="[ form-label ]">
                    {
                      STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                        .EDIT_ADDRESS_DETAILS_MODAL.POSTAL_LABEL
                    }
                  </label>
                  <input
                    id="mailingPostalCode"
                    type="text"
                    name="mailingPostalCode"
                    className={`[ form-control ] ${
                      addressFormErrors.mailingPostalCode
                        ? "[ is-invalid ]"
                        : ""
                    }`}
                    value={addressFormData.mailingPostalCode}
                    onChange={handleAddressInputChange}
                    placeholder={
                      addressFormData.mailingCountry === "CAN"
                        ? STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                            .EDIT_ADDRESS_DETAILS_MODAL.POSTAL_PLACEHOLDER_CAN
                        : STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                            .EDIT_ADDRESS_DETAILS_MODAL.POSTAL_PLACEHOLDER_USA
                    }
                  />
                  {addressFormErrors.mailingPostalCode && (
                    <div className="[ invalid-feedback ]">
                      {addressFormErrors.mailingPostalCode}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="[ divider ]"></div>
      </Modal.Body>

      <Modal.Footer className="[ popup-modal-footer ] [ d-block ]">
        <div className="[ mb-3 ]">
          <button
            type="button"
            className="[ submit-btn btn ] [ w-100 ]"
            onClick={handleSave}
            style={{ borderRadius: ".5em" }}
          >
            {
              STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                .EDIT_ADDRESS_DETAILS_MODAL.SAVE_BUTTON
            }
          </button>
        </div>
        <div className="[ mb-3 text-center ]">
          <span
            className="[ link ]"
            onClick={handleAddressModalClose}
            role="presentation"
            style={{
              textDecoration: "underline",
              color: "#0090c6",
              cursor: "pointer",
            }}
          >
            {
              STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_QUICK_VIEW_PANEL
                .EDIT_ADDRESS_DETAILS_MODAL.CANCEL_BUTTON
            }
          </span>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
